// STAT_AZIENDA_v1 — statistiche dell'azienda dentro 📈 Statistiche:
//   💸 Spese azienda        (dove vanno i soldi, mese per mese, confronto con l'anno prima)
//   ⏱️ Costo orario e pareggio (costo vero di un'ora di lavoro e incassi minimi per andare in pari)
// Legge i documenti della cassetta (/api/cassetta/documenti), i pagamenti dei cantieri e le ore registrate.
import React, { useState, useEffect } from "react";
import { db } from "./firebase";
import { doc, getDoc, setDoc } from "./firebase-shim";

const C = {
  bg: "#0f1117", surface: "#1a1d27", surface2: "#21253a", border: "#2a2e45", accent: "#f5a623", accentSoft: "#f5a62322",
  text: "#e8eaf2", muted: "#7b82a0", dim: "#4a5068", ok: "#3ecf8e", err: "#f06060", info: "#4e9af5",
};
const MESI = ["Gen", "Feb", "Mar", "Apr", "Mag", "Giu", "Lug", "Ago", "Set", "Ott", "Nov", "Dic"];
const MESI_LUNGHI = ["gennaio", "febbraio", "marzo", "aprile", "maggio", "giugno", "luglio", "agosto", "settembre", "ottobre", "novembre", "dicembre"];
const STIP = "Stipendi (netto in busta)";
const F24 = "F24 contributi e ritenute";
const CASSA = "Cassa edile";
const PERSONALE = [STIP, F24, CASSA];
const NON_COSTO = ["IVA versata (non è un costo)", "Documenti (senza spesa)"];

function tok() { try { return localStorage.getItem("bertoc_jwt") || ""; } catch (e) { return ""; } }
async function api(url, opts) {
  const o = opts || {};
  const h = { Authorization: "Bearer " + tok() };
  if (o.body) h["Content-Type"] = "application/json";
  const r = await fetch(url, { method: o.method || "GET", headers: h, body: o.body ? JSON.stringify(o.body) : undefined });
  const j = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(j.error || ("Errore " + r.status));
  return j;
}
// "2026-10-31", "31/10/2026", "1/9/2026" -> "2026-10-31"
function iso(s) {
  const t = String(s || "").trim();
  let m = t.match(/^(\d{4})-(\d{2})-(\d{2})/); if (m) return m[1] + "-" + m[2] + "-" + m[3];
  m = t.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})/); if (m) return m[3] + "-" + m[2].padStart(2, "0") + "-" + m[1].padStart(2, "0");
  return "";
}
function num(v) { const n = Number(v); return isNaN(n) ? 0 : n; }
function valore(x) {
  if (x.categoria === STIP && /busta/i.test(x.tipo || "") && x.netto !== null && x.netto !== undefined) return num(x.netto);
  return x.imponibile !== null && x.imponibile !== undefined ? num(x.imponibile) : num(x.totale);
}
export function meseDoc(x) { return /^\d{4}-\d{2}$/.test(x.mese || "") ? x.mese : String(x.data || "").slice(0, 7); }
// MESE_DOC_v1: nei totali per mese lo stipendio va nel mese della busta, non in quello della data del documento
export function dataCosto(x) { return x.categoria === STIP && /^\d{4}-\d{2}$/.test(x.mese || "") ? x.mese + "-01" : String(x.data || ""); }
function nomeMese(m) { return /^\d{4}-\d{2}$/.test(m || "") ? MESI_LUNGHI[parseInt(m.slice(5, 7), 10) - 1] + " " + m.slice(0, 4) : (m || ""); }
const e0 = n => "€ " + Math.round(num(n)).toLocaleString("it-IT");
const e2 = n => "€ " + num(n).toLocaleString("it-IT", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const h0 = n => Math.round(num(n)).toLocaleString("it-IT") + " h";
const corto = v => { const a = Math.abs(v); if (!a) return "·"; return (v < 0 ? "−" : "") + (a >= 10000 ? Math.round(a / 1000) + "k" : a >= 1000 ? (a / 1000).toFixed(1).replace(".", ",") + "k" : Math.round(a)); };

// Lo stipendio di un mese può arrivare due volte: busta paga (netto) e bonifico.
// Se per quel mese c'è almeno una busta paga, i bonifici degli stipendi di quel mese non si contano.
export function senzaDoppiStipendi(docs) {
  const conBusta = new Set();
  (docs || []).forEach(x => { if (x.categoria === STIP && /busta/i.test(x.tipo || "")) conBusta.add(meseDoc(x)); });
  return (docs || []).filter(x => !(x.categoria === STIP && !/busta/i.test(x.tipo || "") && conBusta.has(meseDoc(x))));
}
// Costi che appartengono a un cantiere (materiali, magazzino, documenti destinati a un cantiere): non sono spese generali
function diretto(x) { return x.categoria === "Materiali cantiere" || ["cantiere", "bolle", "magazzino"].includes(x.destinazione); }

const st = {
  card: { background: C.surface, border: "1px solid " + C.border, borderRadius: 12, padding: 16, marginBottom: 14 },
  titolo: { fontFamily: "'Syne',sans-serif", fontWeight: 700, fontSize: 15, marginBottom: 12 },
  lab: { fontSize: 11, color: C.muted, textTransform: "uppercase", letterSpacing: 0.5 },
  nota: { fontSize: 12, color: C.muted, lineHeight: 1.55 },
  inp: { padding: "7px 10px", fontSize: 15, borderRadius: 8, border: "1px solid " + C.border, background: C.bg, color: C.text, outline: "none", fontFamily: "inherit" },
  chip: on => ({ padding: "6px 14px", borderRadius: 8, cursor: "pointer", fontSize: 13, fontWeight: 600, border: "1px solid " + (on ? C.accent : C.border), background: on ? C.accentSoft : C.bg, color: on ? C.accent : C.muted, userSelect: "none" }),
  btn: primo => ({ padding: "9px 14px", borderRadius: 9, border: "1px solid " + (primo ? C.accent : C.border), background: primo ? C.accent : C.surface, color: primo ? "#1a1d27" : C.text, fontSize: 14, fontWeight: 700, cursor: "pointer", fontFamily: "inherit" }),
};

function Tile({ label, val, sotto, colore }) {
  return (
    <div style={{ background: C.bg, border: "1px solid " + C.border, borderRadius: 10, padding: "12px 14px", minWidth: 0 }}>
      <div style={st.lab}>{label}</div>
      <div style={{ fontFamily: "'Syne',sans-serif", fontWeight: 800, fontSize: 21, color: colore || C.text, marginTop: 4, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{val}</div>
      {sotto ? <div style={{ fontSize: 12, color: C.muted, marginTop: 3 }}>{sotto}</div> : null}
    </div>
  );
}
const griglia = { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(170px, 1fr))", gap: 10, marginBottom: 14 };

function SceltaAnno({ anni, anno, setAnno }) {
  return (
    <div style={{ display: "flex", gap: 8, marginBottom: 16, flexWrap: "wrap" }}>
      {anni.map(a => <div key={a} onClick={() => setAnno(a)} style={st.chip(anno === a)}>{a}</div>)}
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// 💸 SPESE AZIENDA
// ─────────────────────────────────────────────────────────────────────────────
function SpeseAzienda({ documenti, pagamentiDB }) {
  const oggi = new Date();
  const annoOggi = String(oggi.getFullYear());
  const docs = senzaDoppiStipendi(documenti).filter(x => !NON_COSTO.includes(x.categoria));
  const anni = Array.from(new Set(docs.map(x => dataCosto(x).slice(0, 4)).filter(a => /^\d{4}$/.test(a)).concat(annoOggi))).sort().reverse();
  const [anno, setAnno] = useState(annoOggi);
  const [aperta, setAperta] = useState("");
  const annoPrima = String(Number(anno) - 1);
  // per l'anno in corso il confronto è sullo stesso periodo (da gennaio al mese di oggi)
  const fino = anno === annoOggi ? oggi.getMonth() + 1 : 12;

  function raccogli(a, finoMese) {
    const r = { mesi: Array(12).fill(0), tot: 0, cat: {}, forn: {}, n: 0 };
    docs.forEach(x => {
      const d = dataCosto(x);
      if (!d.startsWith(a + "-")) return;
      const m = parseInt(d.slice(5, 7), 10);
      if (!(m >= 1 && m <= finoMese)) return;
      const v = valore(x);
      r.mesi[m - 1] += v; r.tot += v; r.n++;
      const k = x.categoria || "Altro";
      const c = r.cat[k] = r.cat[k] || { tot: 0, n: 0, forn: {} };
      c.tot += v; c.n++;
      const f = (x.categoria === STIP ? (x.lavoratoreNome || x.fornitore) : x.fornitore) || "(senza nome)";
      c.forn[f] = (c.forn[f] || 0) + v;
      const fk = f.toUpperCase().replace(/\s+/g, " ").trim();
      const F = r.forn[fk] = r.forn[fk] || { nome: f, tot: 0, n: 0, cat: {} };
      F.tot += v; F.n++; F.cat[k] = (F.cat[k] || 0) + v;
    });
    return r;
  }
  const A = raccogli(anno, 12);
  const P = raccogli(annoPrima, fino);
  const Atratto = raccogli(anno, fino);
  const inc = Array(12).fill(0), incPrima = Array(12).fill(0);
  (pagamentiDB || []).forEach(p => {
    const d = iso(p.data); const m = parseInt(d.slice(5, 7), 10);
    if (d.startsWith(anno + "-")) inc[m - 1] += num(p.importo);
    if (d.startsWith(annoPrima + "-") && m <= fino) incPrima[m - 1] += num(p.importo);
  });
  const incTot = inc.reduce((s, v) => s + v, 0);
  const incPrimaTot = incPrima.reduce((s, v) => s + v, 0);
  const diff = incTot - A.tot;
  const nMesi = anno === annoOggi ? fino : 12;
  const mesiVuoti = A.mesi.slice(0, nMesi).map((v, i) => v ? null : MESI[i]).filter(Boolean);
  const periodo = fino === 12 ? "tutto il " + annoPrima : "gen–" + MESI[fino - 1].toLowerCase() + " " + annoPrima;
  const delta = (ora, prima) => prima > 0 ? Math.round((ora - prima) / prima * 100) : null;
  const dSpese = delta(Atratto.tot, P.tot);

  const cats = Object.keys(A.cat).sort((a, b) => A.cat[b].tot - A.cat[a].tot);
  const maxCat = Math.max(1, ...cats.map(k => A.cat[k].tot));
  const forn = Object.values(A.forn).sort((a, b) => b.tot - a.tot).slice(0, 15);
  const maxMese = Math.max(1, ...A.mesi, ...inc);

  if (!documenti.length) {
    return <div style={st.card}><div style={st.titolo}>Nessun documento nella cassetta</div><div style={st.nota}>Le spese si leggono dai documenti confermati in 📥 Cassetta: fatture XML da Tieni il Conto, F24, buste paga, Cassa edile, bollette… Più documenti ci sono, più il quadro è vero.</div></div>;
  }

  return (
    <div>
      <SceltaAnno anni={anni} anno={anno} setAnno={a => { setAnno(a); setAperta(""); }} />
      <div style={griglia}>
        <Tile label={"Spese " + anno} val={e0(A.tot)} sotto={A.n + " documenti · senza IVA"} colore={C.err} />
        <Tile label={"Incassi " + anno} val={e0(incTot)} sotto="dai pagamenti dei cantieri" colore={C.ok} />
        <Tile label="Incassi − spese" val={e0(diff)} colore={diff >= 0 ? C.ok : C.err} />
        <Tile label={"Spese rispetto al " + annoPrima} val={dSpese === null ? "—" : (dSpese > 0 ? "+" : "") + dSpese + "%"} sotto={P.tot > 0 ? periodo + ": " + e0(P.tot) : "nessun documento del " + annoPrima} colore={dSpese === null ? C.muted : dSpese > 0 ? C.err : C.ok} />
      </div>
      {mesiVuoti.length > 0 && (
        <div style={{ ...st.card, borderColor: C.accent, fontSize: 13 }}>
          ⚠️ Mesi del {anno} senza nessun documento: <b>{mesiVuoti.join(", ")}</b>. Finché non li carichi nella cassetta, le spese di quei mesi risultano zero.
        </div>
      )}

      <div style={st.card}>
        <div style={st.titolo}>Mese per mese</div>
        <div style={{ display: "flex", gap: 14, fontSize: 12, color: C.muted, marginBottom: 10 }}>
          <span><span style={{ display: "inline-block", width: 10, height: 10, borderRadius: 2, background: C.err, marginRight: 5 }} />Spese</span>
          <span><span style={{ display: "inline-block", width: 10, height: 10, borderRadius: 2, background: C.ok, marginRight: 5 }} />Incassi</span>
        </div>
        <div style={{ overflowX: "auto" }}>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(12, minmax(46px, 1fr))", gap: 6, minWidth: 600 }}>
            {MESI.map((m, i) => {
              const sp = A.mesi[i], ic = inc[i], d = ic - sp;
              return (
                <div key={m} style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                  <div style={{ height: 130, width: "100%", display: "flex", alignItems: "flex-end", justifyContent: "center", gap: 3 }}>
                    <div title={"Spese " + e0(sp)} style={{ width: "42%", height: Math.max(sp ? 3 : 1, Math.round(sp / maxMese * 126)), background: sp ? C.err : C.border, borderRadius: "3px 3px 0 0" }} />
                    <div title={"Incassi " + e0(ic)} style={{ width: "42%", height: Math.max(ic ? 3 : 1, Math.round(ic / maxMese * 126)), background: ic ? C.ok : C.border, borderRadius: "3px 3px 0 0" }} />
                  </div>
                  <div style={{ fontSize: 11, color: C.muted, marginTop: 5 }}>{m}</div>
                  <div style={{ fontSize: 11, fontWeight: 700, color: !sp && !ic ? C.dim : d >= 0 ? C.ok : C.err }}>{sp || ic ? corto(d) : "·"}</div>
                </div>
              );
            })}
          </div>
        </div>
        <div style={{ ...st.nota, marginTop: 8 }}>Il numero sotto ogni mese è incassi − spese. Le spese vanno nel mese della data del documento (gli stipendi nel mese della busta), gli incassi nel mese del pagamento.</div>
      </div>

      <div style={st.card}>
        <div style={st.titolo}>Dove vanno i soldi</div>
        {cats.length === 0 && <div style={st.nota}>Nessuna spesa registrata nel {anno}.</div>}
        {cats.map(k => {
          const c = A.cat[k];
          const prima = P.cat[k] ? P.cat[k].tot : 0;
          const ora = Atratto.cat[k] ? Atratto.cat[k].tot : 0;
          const dd = delta(ora, prima);
          const fl = Object.entries(c.forn).sort((a, b) => b[1] - a[1]);
          return (
            <div key={k} style={{ borderTop: "1px solid " + C.border, padding: "9px 0" }}>
              <div onClick={() => setAperta(aperta === k ? "" : k)} style={{ cursor: "pointer" }}>
                <div style={{ display: "flex", justifyContent: "space-between", gap: 10, fontSize: 14 }}>
                  <span style={{ minWidth: 0 }}>{aperta === k ? "▾" : "▸"} {k} <span style={{ color: C.dim, fontSize: 12 }}>· {c.n} doc.</span></span>
                  <span style={{ whiteSpace: "nowrap" }}>
                    <b>{e0(c.tot)}</b>
                    <span style={{ color: C.muted, fontSize: 12 }}> · {Math.round(c.tot / (A.tot || 1) * 100)}%</span>
                    {dd !== null && <span style={{ fontSize: 12, marginLeft: 6, color: dd > 0 ? C.err : C.ok }}>{dd > 0 ? "▲" : "▼"} {Math.abs(dd)}%</span>}
                  </span>
                </div>
                <div style={{ height: 6, background: C.bg, borderRadius: 3, marginTop: 6 }}>
                  <div style={{ width: Math.max(1, c.tot / maxCat * 100) + "%", height: 6, background: PERSONALE.includes(k) ? C.info : diretto({ categoria: k }) ? C.muted : C.accent, borderRadius: 3 }} />
                </div>
              </div>
              {aperta === k && (
                <div style={{ marginTop: 8, paddingLeft: 16 }}>
                  {fl.slice(0, 12).map(([f, v]) => (
                    <div key={f} style={{ display: "flex", justifyContent: "space-between", fontSize: 13, padding: "3px 0", color: C.muted }}>
                      <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", minWidth: 0 }}>{f}</span><span style={{ color: C.text, whiteSpace: "nowrap", marginLeft: 10 }}>{e0(v)}</span>
                    </div>
                  ))}
                  {fl.length > 12 && <div style={{ fontSize: 12, color: C.dim }}>…e altri {fl.length - 12}</div>}
                  {prima > 0 && <div style={{ fontSize: 12, color: C.dim, marginTop: 4 }}>{periodo}: {e0(prima)} · {anno} stesso periodo: {e0(ora)}</div>}
                </div>
              )}
            </div>
          );
        })}
        <div style={{ ...st.nota, marginTop: 10 }}>
          <span style={{ color: C.info }}>■</span> personale · <span style={{ color: C.muted }}>■</span> materiali e costi dei cantieri · <span style={{ color: C.accent }}>■</span> spese generali. Tocca una categoria per vedere i fornitori. La freccia confronta lo stesso periodo del {annoPrima}.
        </div>
      </div>

      <div style={st.card}>
        <div style={st.titolo}>Fornitori principali del {anno}</div>
        <div style={{ overflowX: "auto" }}>
          <table style={{ borderCollapse: "collapse", width: "100%", fontSize: 13, minWidth: 460 }}>
            <thead><tr style={{ color: C.muted, textAlign: "left" }}>
              <th style={{ padding: "6px 4px", fontWeight: 600 }}>Fornitore</th><th style={{ padding: "6px 4px", fontWeight: 600 }}>Categoria</th>
              <th style={{ padding: "6px 4px", fontWeight: 600, textAlign: "right" }}>Doc.</th><th style={{ padding: "6px 4px", fontWeight: 600, textAlign: "right" }}>Totale</th>
            </tr></thead>
            <tbody>
              {forn.map(f => {
                const cp = Object.entries(f.cat).sort((a, b) => b[1] - a[1])[0];
                return (
                  <tr key={f.nome} style={{ borderTop: "1px solid " + C.border }}>
                    <td style={{ padding: "6px 4px" }}>{f.nome}</td>
                    <td style={{ padding: "6px 4px", color: C.muted }}>{cp ? cp[0] : ""}</td>
                    <td style={{ padding: "6px 4px", textAlign: "right", color: C.muted }}>{f.n}</td>
                    <td style={{ padding: "6px 4px", textAlign: "right", fontWeight: 700 }}>{e0(f.tot)}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
      <div style={{ ...st.nota, marginBottom: 20 }}>
        Importi senza IVA. Non sono costi e restano fuori: IVA versata e documenti senza spesa. Stipendi: conta il netto della busta paga; il bonifico dello stipendio si conta solo se manca la busta di quel mese. Gli incassi sono quelli segnati nei pagamenti dei cantieri.
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// ⏱️ COSTO ORARIO E PAREGGIO
// ─────────────────────────────────────────────────────────────────────────────
function CostoOrario({ documenti, setDocumenti, pagamentiDB, assenzeDB, dipendenti, costoOrarioAttuale }) {
  const oggi = new Date();
  const annoOggi = String(oggi.getFullYear());
  const meseOggi = annoOggi + "-" + String(oggi.getMonth() + 1).padStart(2, "0");
  const docs = senzaDoppiStipendi(documenti);
  const ore = (assenzeDB || []).filter(a => a.tipo === "lavorato").map(a => ({ op: String(a.operaio || "").trim() || "(senza nome)", m: iso(a.data).slice(0, 7), h: num(a.ore) })).filter(a => a.m);
  const anni = Array.from(new Set(ore.map(a => a.m.slice(0, 4)).concat(docs.map(x => meseDoc(x).slice(0, 4))).filter(a => /^\d{4}$/.test(a)).concat(annoOggi))).sort().reverse();
  const [anno, setAnno] = useState(annoOggi);
  const [scelti, setScelti] = useState(null);      // null = mesi completi
  const [esclusi, setEsclusi] = useState(null);    // null = titolari esclusi
  const [catVia, setCatVia] = useState({});        // categorie tolte dalle spese generali
  const [param, setParam] = useState({ comp: "", altri: "" });
  const [costoNuovo, setCostoNuovo] = useState(null);
  const [vediDoc, setVediDoc] = useState(false);
  const [msg, setMsg] = useState("");

  useEffect(() => {
    getDoc(doc(db, "impostazioni", "params")).then(s => {
      const v = (s && s.exists && s.exists() ? (s.data().voci || {}) : {});
      setParam({ comp: v.compensoTitolareMese ? String(v.compensoTitolareMese) : "", altri: v.altriCostiPersonaleMese ? String(v.altriCostiPersonaleMese) : "" });
    }).catch(() => {});
  }, []);
  async function salvaParam(campi) {
    try {
      const s = await getDoc(doc(db, "impostazioni", "params"));
      const v = s && s.exists && s.exists() ? (s.data().voci || {}) : {};
      await setDoc(doc(db, "impostazioni", "params"), { voci: { ...v, ...campi }, updatedAt: new Date().toISOString() });
      return true;
    } catch (e) { alert("Non salvato: " + e.message); return false; }
  }
  async function usaCosto(val, che) {
    const v = Math.round(val * 100) / 100;
    if (!window.confirm("Impostare il costo orario operaio a " + e2(v) + " (" + che + ")?\n\nOggi è " + e2(costoNuovo || costoOrarioAttuale) + ". Il valore si usa nei margini del consuntivo, nelle statistiche dei cantieri e nelle barre dei costi. Lo puoi sempre cambiare da Impostazioni.")) return;
    if (await salvaParam({ costoOraio: v })) { setCostoNuovo(v); setMsg("✓ Costo orario impostato a " + e2(v) + ". Le altre pagine lo prendono entro pochi secondi."); setTimeout(() => setMsg(""), 6000); }
  }
  async function cambiaMese(x, m) {
    try {
      await api("/api/cassetta/documenti/" + x.id, { method: "PATCH", body: { mese: m } });
      setDocumenti(ds => ds.map(y => y.id === x.id ? { ...y, mese: m } : y));
    } catch (e) { alert(e.message); }
  }

  const nMesi = anno === annoOggi ? oggi.getMonth() + 1 : 12;
  const mesi = Array.from({ length: nMesi }, (_, i) => anno + "-" + String(i + 1).padStart(2, "0"));
  const titolari = new Set((dipendenti || []).filter(d => d.ruolo === "Titolare").map(d => String(d.nome || "").trim()));
  const operai = {};
  ore.filter(a => a.m.startsWith(anno + "-")).forEach(a => { operai[a.op] = (operai[a.op] || 0) + a.h; });
  const nomiOp = Object.keys(operai).sort((a, b) => operai[b] - operai[a]);
  const comp = num(String(param.comp).replace(",", ".")), altri = num(String(param.altri).replace(",", "."));
  // ore dei titolari: dentro solo se c'è il compenso del titolare (altrimenti abbasserebbero il costo orario)
  const fuori = esclusi || new Set(comp > 0 ? [] : nomiOp.filter(n => titolari.has(n)));

  // personale: per mese di riferimento (il campo Mese della scheda); il resto: per data del documento
  const riga = {};
  mesi.forEach(m => { riga[m] = { m, ore: 0, netti: 0, buste: 0, f24: 0, cassa: 0, gen: 0, dir: 0, inc: 0 }; });
  ore.forEach(a => { if (riga[a.m] && !fuori.has(a.op)) riga[a.m].ore += a.h; });
  const genCat = {};
  let genPrimo = null, genUltimo = null;
  docs.forEach(x => {
    if (NON_COSTO.includes(x.categoria)) return;
    const v = valore(x);
    if (PERSONALE.includes(x.categoria)) {
      const r = riga[meseDoc(x)]; if (!r) return;
      if (x.categoria === STIP) { r.netti += v; if (/busta/i.test(x.tipo || "")) r.buste++; }
      else if (x.categoria === F24) r.f24 += v; else r.cassa += v;
      return;
    }
    const md = String(x.data || "").slice(0, 7);
    if (!md.startsWith(anno + "-")) return;
    if (diretto(x)) { if (riga[md]) riga[md].dir += v; return; }
    const k = x.categoria || "Altro";
    genCat[k] = (genCat[k] || 0) + v;
    if (catVia[k]) return;
    if (riga[md]) riga[md].gen += v;
    if (!genPrimo || md < genPrimo) genPrimo = md;
    if (!genUltimo || md > genUltimo) genUltimo = md;
  });
  (pagamentiDB || []).forEach(p => { const m = iso(p.data).slice(0, 7); if (riga[m]) riga[m].inc += num(p.importo); });
  mesi.forEach(m => {
    const r = riga[m];
    r.manca = [];
    if (!r.ore) r.manca.push("ore");
    if (!r.buste) r.manca.push("buste paga");
    if (!r.f24) r.manca.push("F24");
    r.completo = r.manca.length === 0 && m < meseOggi;
    if (m >= meseOggi) r.manca.unshift("mese in corso");
    r.senzaCassa = !r.cassa;
  });
  const sel = scelti || new Set(mesi.filter(m => riga[m].completo));
  const lista = mesi.filter(m => sel.has(m));
  const n = lista.length;

  // spese generali spalmate: alcune si pagano una volta l'anno (assicurazioni, bolli…)
  const spanMesi = genPrimo ? (parseInt(genUltimo.slice(5, 7), 10) - parseInt(genPrimo.slice(5, 7), 10) + 1) : 0;
  const genTot = Object.keys(genCat).filter(k => !catVia[k]).reduce((s, k) => s + genCat[k], 0);
  const genMedia = spanMesi ? genTot / spanMesi : 0;

  const S = lista.reduce((s, m) => { const r = riga[m]; return { ore: s.ore + r.ore, netti: s.netti + r.netti, f24: s.f24 + r.f24, cassa: s.cassa + r.cassa, dir: s.dir + r.dir, inc: s.inc + r.inc }; }, { ore: 0, netti: 0, f24: 0, cassa: 0, dir: 0, inc: 0 });
  const manuali = (comp + altri) * n;
  const Pers = S.netti + S.f24 + S.cassa + manuali;
  const Gen = genMedia * n;
  const costoMan = S.ore ? Pers / S.ore : 0;
  const quotaGen = S.ore ? Gen / S.ore : 0;
  const pieno = costoMan + quotaGen;
  const sogliaMese = n ? (Pers + Gen + S.dir) / n : 0;
  const incMese = n ? S.inc / n : 0;
  const attuale = costoNuovo || costoOrarioAttuale;
  const docPers = documenti.filter(x => PERSONALE.includes(x.categoria) && (meseDoc(x).startsWith(anno + "-") || String(x.data || "").startsWith(anno + "-")))
    .sort((a, b) => meseDoc(a).localeCompare(meseDoc(b)) || String(a.categoria).localeCompare(String(b.categoria)));
  const opzMesi = [];
  for (let i = -12; i <= 12; i++) { const d = new Date(Number(anno), i, 1); opzMesi.push(d.getFullYear() + "-" + String(d.getMonth() + 1).padStart(2, "0")); }

  const toggleMese = m => { const s = new Set(sel); if (s.has(m)) s.delete(m); else s.add(m); setScelti(s); };
  const toggleOp = o => { const s = new Set(fuori); if (s.has(o)) s.delete(o); else s.add(o); setEsclusi(s); };
  const td = { padding: "7px 6px", textAlign: "right", whiteSpace: "nowrap" };
  const tdNum = v => <td style={{ ...td, color: v ? C.text : C.dim }}>{v ? Math.round(v).toLocaleString("it-IT") : "·"}</td>;

  return (
    <div>
      <SceltaAnno anni={anni} anno={anno} setAnno={a => { setAnno(a); setScelti(null); setEsclusi(null); }} />
      {msg && <div style={{ ...st.card, borderColor: C.ok, color: C.ok }}>{msg}</div>}

      <div style={griglia}>
        <Tile label="Costo manodopera" val={S.ore ? e2(costoMan) + "/h" : "—"} sotto="stipendi + F24 + Cassa edile" colore={C.info} />
        <Tile label="+ Spese generali" val={S.ore ? e2(quotaGen) + "/h" : "—"} sotto={e0(genMedia) + " al mese"} colore={C.accent} />
        <Tile label="= Costo orario pieno" val={S.ore ? e2(pieno) + "/h" : "—"} sotto={"oggi impostato: " + e2(attuale)} colore={pieno > attuale ? C.err : C.ok} />
        <Tile label="Pareggio al mese" val={n ? e0(sogliaMese) : "—"} sotto={n ? "incassati in media " + e0(incMese) : "scegli i mesi qui sotto"} colore={n ? (incMese >= sogliaMese ? C.ok : C.err) : C.muted} />
      </div>

      {n === 0 ? (
        <div style={{ ...st.card, borderColor: C.accent, fontSize: 14, lineHeight: 1.6 }}>
          ⚠️ <b>Nessun mese completo nel {anno}.</b> Un mese è completo quando ci sono le ore registrate, le buste paga e l'F24 dei contributi di quel mese. Carica nella 📥 Cassetta buste paga, F24 e Cassa edile dei mesi passati, oppure spunta a mano un mese nella tabella qui sotto.
        </div>
      ) : (
        <div style={{ ...st.card, fontSize: 14, lineHeight: 1.7 }}>
          <div style={st.titolo}>Calcolo su {n === 1 ? "1 mese" : n + " mesi"}: {lista.map(m => MESI[parseInt(m.slice(5, 7), 10) - 1]).join(", ")}</div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr auto", gap: "2px 16px", maxWidth: 520 }}>
            <span>Netti in busta</span><b style={{ textAlign: "right" }}>{e0(S.netti)}</b>
            <span>F24 contributi e ritenute</span><b style={{ textAlign: "right" }}>{e0(S.f24)}</b>
            <span>Cassa edile</span><b style={{ textAlign: "right" }}>{e0(S.cassa)}</b>
            {manuali > 0 && <><span>Compenso titolare e altri costi ({n} × {e0(comp + altri)})</span><b style={{ textAlign: "right" }}>{e0(manuali)}</b></>}
            <span style={{ color: C.info }}>Costo del personale</span><b style={{ textAlign: "right", color: C.info }}>{e0(Pers)}</b>
            <span style={{ color: C.accent }}>Spese generali ({n} × {e0(genMedia)})</span><b style={{ textAlign: "right", color: C.accent }}>{e0(Gen)}</b>
            <span>Ore lavorate registrate</span><b style={{ textAlign: "right" }}>{h0(S.ore)}</b>
          </div>
          <div style={{ marginTop: 12, paddingTop: 12, borderTop: "1px solid " + C.border }}>
            Un'ora di lavoro costa <b style={{ color: C.info }}>{e2(costoMan)}</b> di manodopera, che con le spese generali diventa <b style={{ color: C.accent }}>{e2(pieno)}</b>. Nel gestionale oggi è impostato <b>{e2(attuale)}</b>.
          </div>
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginTop: 12 }}>
            <button style={st.btn(true)} disabled={!S.ore} onClick={() => usaCosto(pieno, "costo pieno")}>Usa {e2(pieno)} (pieno)</button>
            <button style={st.btn(false)} disabled={!S.ore} onClick={() => usaCosto(costoMan, "solo manodopera")}>Usa {e2(costoMan)} (solo manodopera)</button>
          </div>
          <div style={{ ...st.nota, marginTop: 8 }}>Col costo pieno, il margine dei cantieri diventa un margine vero, dopo aver pagato anche ufficio, mezzi e assicurazioni. Con quello di sola manodopera resta il margine di cantiere.</div>
          <div style={{ marginTop: 14, paddingTop: 12, borderTop: "1px solid " + C.border }}>
            <b>Punto di pareggio.</b> Per andare in pari servono in media <b>{e0(sogliaMese)}</b> di incassi al mese senza IVA (circa <b>{e0(sogliaMese * 12)}</b> l'anno): personale {e0(Pers / n)} + spese generali {e0(genMedia)} + materiali e costi dei cantieri {e0(S.dir / n)}.
            Nei mesi scelti sono entrati in media <b style={{ color: incMese >= sogliaMese ? C.ok : C.err }}>{e0(incMese)}</b> al mese: {incMese >= sogliaMese ? "sopra il pareggio di " + e0(incMese - sogliaMese) : "sotto il pareggio di " + e0(sogliaMese - incMese)}.
            <div style={{ height: 10, background: C.bg, borderRadius: 5, marginTop: 10, position: "relative", maxWidth: 520 }}>
              <div style={{ width: Math.min(100, sogliaMese ? incMese / sogliaMese * 100 : 0) + "%", height: 10, background: incMese >= sogliaMese ? C.ok : C.err, borderRadius: 5 }} />
            </div>
            <div style={{ ...st.nota, marginTop: 6 }}>Gli incassi di un mese pagano spesso lavori dei mesi prima: su pochi mesi il confronto oscilla, su un anno intero è affidabile.</div>
          </div>
        </div>
      )}

      <div style={st.card}>
        <div style={st.titolo}>Mesi del {anno}</div>
        <div style={{ ...st.nota, marginBottom: 10 }}>Spunta i mesi da usare nel calcolo. Di base sono scelti solo i mesi completi (ore + buste paga + F24).</div>
        <div style={{ overflowX: "auto" }}>
          <table style={{ borderCollapse: "collapse", width: "100%", fontSize: 13, minWidth: 820 }}>
            <thead>
              <tr style={{ background: C.surface2, color: C.muted }}>
                <th style={{ padding: "8px 6px", textAlign: "left" }}>Mese</th>
                <th style={{ ...td, fontWeight: 600 }}>Ore</th>
                <th style={{ ...td, fontWeight: 600 }}>Buste</th>
                <th style={{ ...td, fontWeight: 600 }}>Netti</th>
                <th style={{ ...td, fontWeight: 600 }}>F24</th>
                <th style={{ ...td, fontWeight: 600 }}>Cassa ed.</th>
                <th style={{ ...td, fontWeight: 600 }}>Generali</th>
                <th style={{ ...td, fontWeight: 600 }}>Cantieri</th>
                <th style={{ ...td, fontWeight: 600 }}>Incassi</th>
                <th style={{ ...td, fontWeight: 600 }}>€/h man.</th>
                <th style={{ padding: "8px 6px", textAlign: "left", fontWeight: 600 }}>Stato</th>
              </tr>
            </thead>
            <tbody>
              {mesi.map(m => {
                const r = riga[m];
                const on = sel.has(m);
                const ch = r.ore ? (r.netti + r.f24 + r.cassa + comp + altri) / r.ore : 0;
                return (
                  <tr key={m} onClick={() => toggleMese(m)} style={{ borderTop: "1px solid " + C.border, cursor: "pointer", background: on ? C.accentSoft : "transparent" }}>
                    <td style={{ padding: "7px 6px", whiteSpace: "nowrap" }}><input type="checkbox" readOnly checked={on} style={{ marginRight: 6, verticalAlign: "middle" }} />{MESI[parseInt(m.slice(5, 7), 10) - 1]}</td>
                    <td style={{ ...td, color: r.ore ? C.text : C.dim }}>{r.ore ? Math.round(r.ore) : "·"}</td>
                    <td style={{ ...td, color: r.buste ? C.text : C.dim }}>{r.buste || "·"}</td>
                    {tdNum(r.netti)}{tdNum(r.f24)}{tdNum(r.cassa)}{tdNum(r.gen)}{tdNum(r.dir)}
                    <td style={{ ...td, color: r.inc ? C.ok : C.dim }}>{r.inc ? Math.round(r.inc).toLocaleString("it-IT") : "·"}</td>
                    <td style={{ ...td, fontWeight: 700, color: r.completo ? C.info : C.dim }}>{r.completo && ch ? ch.toFixed(2).replace(".", ",") : "·"}</td>
                    <td style={{ padding: "7px 6px", fontSize: 12, color: r.completo ? C.ok : C.muted }}>
                      {r.completo ? "✓ completo" : "manca: " + r.manca.join(", ")}{r.completo && r.senzaCassa ? <span style={{ color: C.accent }}> · senza Cassa edile</span> : null}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <div style={{ ...st.nota, marginTop: 8 }}>
          Buste, netti, F24 e Cassa edile stanno nel <b>mese a cui si riferiscono</b> (l'F24 pagato il 16 ottobre va su settembre), le altre spese e gli incassi nel mese della data. La colonna "Generali" mostra le spese del mese così come arrivano; nel calcolo invece sono spalmate in media sui mesi ({spanMesi ? nomeMese(genPrimo) + " – " + nomeMese(genUltimo) + ": " + e0(genTot) : "nessuna spesa generale nel " + anno}).
        </div>
      </div>

      <div style={st.card}>
        <div style={st.titolo}>Cosa entra nel calcolo</div>
        <div style={{ ...st.lab, marginBottom: 6 }}>Ore di chi</div>
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 6 }}>
          {nomiOp.length === 0 && <span style={st.nota}>Nessuna ora registrata nel {anno}.</span>}
          {nomiOp.map(o => <div key={o} onClick={() => toggleOp(o)} style={st.chip(!fuori.has(o))}>{fuori.has(o) ? "○" : "✓"} {o} · {Math.round(operai[o])} h</div>)}
        </div>
        <div style={{ ...st.nota, marginBottom: 14 }}>Di base le ore dei titolari contano solo se qui sotto c'è il compenso del titolare: senza compenso abbasserebbero il costo orario. Tocca un nome per toglierlo o rimetterlo.</div>

        <div style={{ display: "flex", gap: 16, flexWrap: "wrap", marginBottom: 6 }}>
          <label style={{ minWidth: 220 }}>
            <div style={st.lab}>Compenso titolare (€ al mese)</div>
            <input style={{ ...st.inp, width: 150, marginTop: 4 }} inputMode="decimal" value={param.comp} placeholder="0"
              onChange={e => setParam({ ...param, comp: e.target.value })}
              onBlur={() => salvaParam({ compensoTitolareMese: num(String(param.comp).replace(",", ".")) })} />
          </label>
          <label style={{ minWidth: 220 }}>
            <div style={st.lab}>Altri costi del personale (€ al mese)</div>
            <input style={{ ...st.inp, width: 150, marginTop: 4 }} inputMode="decimal" value={param.altri} placeholder="0"
              onChange={e => setParam({ ...param, altri: e.target.value })}
              onBlur={() => salvaParam({ altriCostiPersonaleMese: num(String(param.altri).replace(",", ".")) })} />
          </label>
        </div>
        <div style={{ ...st.nota, marginBottom: 14 }}>Le cifre le dà il commercialista o il consulente del lavoro. "Altri costi" è quello che non passa dalla cassetta: TFR accantonato, ratei di tredicesima e quattordicesima se non sono già nelle buste, INAIL se non lo carichi come F24.</div>

        <div style={{ ...st.lab, marginBottom: 6 }}>Spese generali del {anno} (tocca per toglierne una dal calcolo)</div>
        {Object.keys(genCat).length === 0 && <div style={st.nota}>Nessuna spesa generale registrata nel {anno}.</div>}
        {Object.entries(genCat).sort((a, b) => b[1] - a[1]).map(([k, v]) => (
          <div key={k} onClick={() => setCatVia({ ...catVia, [k]: !catVia[k] })} style={{ display: "flex", justifyContent: "space-between", fontSize: 13, padding: "5px 0", cursor: "pointer", color: catVia[k] ? C.dim : C.text, textDecoration: catVia[k] ? "line-through" : "none", borderTop: "1px solid " + C.border }}>
            <span>{catVia[k] ? "○" : "✓"} {k}</span><span>{e0(v)}</span>
          </div>
        ))}
        <div style={{ ...st.nota, marginTop: 8 }}>Fuori dalle spese generali: materiali, magazzino e tutto ciò che è destinato a un cantiere (sono costi del cantiere, contano solo nel pareggio), IVA versata, documenti senza spesa. Le imposte sull'utile (IRES, IRAP) di solito vanno tolte da qui.</div>
      </div>

      <div style={st.card}>
        <div onClick={() => setVediDoc(!vediDoc)} style={{ ...st.titolo, marginBottom: 0, cursor: "pointer" }}>{vediDoc ? "▾" : "▸"} Documenti del personale del {anno} ({docPers.length})</div>
        {vediDoc && (
          <div style={{ marginTop: 10 }}>
            <div style={{ ...st.nota, marginBottom: 8 }}>Se un F24 o una Cassa edile è finito nel mese sbagliato, correggi qui il mese di riferimento.</div>
            {docPers.length === 0 && <div style={st.nota}>Nessun documento del personale nel {anno}.</div>}
            {docPers.map(x => {
              const ignorato = !docs.includes(x);
              return (
                <div key={x.id} style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap", borderTop: "1px solid " + C.border, padding: "6px 0", fontSize: 13, opacity: ignorato ? 0.5 : 1 }}>
                  <select value={meseDoc(x)} onChange={e => cambiaMese(x, e.target.value)} style={{ ...st.inp, fontSize: 13, padding: "4px 6px" }}>
                    {(opzMesi.includes(meseDoc(x)) ? opzMesi : [meseDoc(x)].concat(opzMesi)).map(m => <option key={m} value={m}>{nomeMese(m)}</option>)}
                  </select>
                  <span style={{ color: C.muted, minWidth: 90 }}>{x.tipo}</span>
                  <span style={{ flex: 1, minWidth: 140 }}>{x.lavoratoreNome || x.descrizione || x.fornitore}</span>
                  <span style={{ color: C.dim }}>{String(x.data || "").split("-").reverse().join("/")}</span>
                  <b style={{ minWidth: 80, textAlign: "right" }}>{e0(valore(x))}</b>
                  {ignorato && <span style={{ fontSize: 11, color: C.dim }}>non contato: c'è la busta</span>}
                </div>
              );
            })}
          </div>
        )}
      </div>
      <div style={{ ...st.nota, marginBottom: 20 }}>
        I conti sono veri solo quanto lo sono i documenti caricati: per ogni mese servono tutte le buste paga, gli F24 dei contributi e la Cassa edile. Il costo aziendale pieno del personale lo conferma il consulente del lavoro.
      </div>
    </div>
  );
}

export default function StatisticheAzienda({ vista, pagamentiDB = [], assenzeDB = [], dipendenti = [], costoOrarioAttuale = 25 }) {
  const [documenti, setDocumenti] = useState(null);
  const [errore, setErrore] = useState("");
  useEffect(() => {
    api("/api/cassetta/documenti").then(d => setDocumenti(d.documenti || [])).catch(e => { setErrore(e.message); setDocumenti([]); });
  }, []);
  if (documenti === null) return <div style={{ ...st.card, color: C.muted }}>Carico i documenti della cassetta…</div>;
  return (
    <div style={{ color: C.text }}>
      {errore && <div style={{ ...st.card, borderColor: C.err, color: C.err }}>⚠️ Documenti della cassetta non letti: {errore}</div>}
      {vista === "spese"
        ? <SpeseAzienda documenti={documenti} pagamentiDB={pagamentiDB} />
        : <CostoOrario documenti={documenti} setDocumenti={setDocumenti} pagamentiDB={pagamentiDB} assenzeDB={assenzeDB} dipendenti={dipendenti} costoOrarioAttuale={costoOrarioAttuale} />}
    </div>
  );
}
